// Cache for loaded templates to avoid repeated fetches
const templateCache = new Map<string, string>();

export async function loadTemplate(templatePath: string): Promise<string> {
  if (templateCache.has(templatePath)) {
    return templateCache.get(templatePath)!;
  }

  const response = await fetch(templatePath);
  if (!response.ok) {
    throw new Error(`Failed to load template: ${templatePath}`);
  }

  const template = await response.text();
  templateCache.set(templatePath, template);
  return template;
}

export function clearTemplateCache(): void {
  templateCache.clear();
}
